import type { ValidationResult } from 'Automations/nodeDefinitions/validation'

/**
 * Narrows a condition's value errors to one sub-input. Validators tag each
 * result with `metadata.field`, so an editor routes every message to its own
 * control rather than showing all of them on each.
 */
export const filterErrorsByField = (
  errors: ValidationResult[] | undefined,
  field: string
): ValidationResult[] | undefined =>
  errors?.filter(error => error.metadata?.field === field)
